module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "one",
    class: {
      out: _vm.closing
    },
    attrs: {
      "id": "modal-container"
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('svg', {
    staticClass: "close",
    attrs: {
      "version": "1.1",
      "id": "Cross",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    },
    on: {
      "click": _vm.out
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M14.348,14.849c-0.469,0.469-1.229,0.469-1.697,0L10,11.819l-2.651,3.029c-0.469,0.469-1.229,0.469-1.697,0\n                            c-0.469-0.469-0.469-1.229,0-1.697l2.758-3.15L5.651,6.849c-0.469-0.469-0.469-1.228,0-1.697s1.228-0.469,1.697,0L10,8.183\n                            l2.651-3.031c0.469-0.469,1.228-0.469,1.697,0s0.469,1.229,0,1.697l-2.758,3.152l2.758,3.15\n                            C14.817,13.62,14.817,14.38,14.348,14.849z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default", [_vm._v("This is empty")])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de96697c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/fullscreen-modal.vue
// module id = 186
// module chunks = 4